import { createAtomObserver } from '@exodus/atoms';
export const BACKED_UP_EVENT = 'backedUp';
const walletPluginDefinition = {
    id: 'walletPlugin',
    type: 'plugin',
    factory: ({ backedUpAtom, port }) => {
        const observers = [
            createAtomObserver({
                atom: backedUpAtom,
                port,
                event: BACKED_UP_EVENT,
            }),
        ];
        observers.forEach((observer) => observer.register());
        return {
            onLoad: () => {
                observers.forEach((observer) => observer.start());
            },
            onStop: () => {
                observers.forEach((observer) => observer.unregister());
            },
            onClear: async () => {
                await backedUpAtom.set(undefined);
            },
        };
    },
    dependencies: ['backedUpAtom', 'port'],
};
export default walletPluginDefinition;
